// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

import { cn } from "@granite/ui";

/** A sidebar row: icon, label, optional trailing content (AppShell, NotificationsBell, the vault sidebar). */
export const rowClass = (active: boolean) =>
  cn(
    "flex h-7 items-center gap-2 rounded-md px-2 text-[13px] font-medium whitespace-nowrap transition-colors outline-offset-[-2px] [&>svg]:size-4 [&>svg]:shrink-0",
    active ? "bg-surface-muted text-fg [&>svg]:text-accent" : "text-fg-muted hover:bg-surface-muted/60 hover:text-fg",
  );
